import { v1 as uuidv1 } from 'uuid';

// @ts-ignore: there might be a better way to do this without using 'any', but trying
// a few other strategies didn't work and caused all kinds of typing dominos.
// Moving on for now.
export const createObjectWithId = (data: any, idKey = 'id') => ({
  ...data,
  [idKey]: uuidv1(), // Using v1 so it's sequential
});
